<template>
    <div class="w-full z-2 font-fira text-white font-hairline h-auto overflow-hidden relative">
        <img class="absolute z-0 img w-full" src="../assets/contact_bg.png">
        <div class="flex flex-col md:flex-row">
            <div class="formblock xl:block bg-v-white-trans hidden h-full z-10 whiter">
            </div>
            <div class="z-10 flex flex-col bg-v-magenta md:w-1/2 mt-8 mr-6 mb-8 md:mr-0 md:mb-0 xl:mb-8 forminfo">
                <contact-info class="lg:mt-8 lg:mx-8"></contact-info>
            </div>
            <div class="formblock contact__form md:mt-8 md:w-1/2 xl:w-1/3 w-full bg-v-white-trans">
                <contact-form class="w-full p-8"></contact-form>
            </div>
        </div>
    </div>
</template>

<script>
import contactForm from './ContactForm'
import contactInfo from './ContactInfo'

export default {
  components: {contactForm, contactInfo}

}
</script>
<style lang="scss" scoped>
    .contact__form {
        @media (min-width: 1200px) {
            width: 500px;
        }
        z-index: 2;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        display: block;
        object-position: right;
    }

    .contact__infos {
        top: 8%;
        left: 120px;
        height: 850px;
    }

    .formblock {
        @media (min-width: 1200px) {
            margin-top: 100px;
            margin-bottom: 100px;
            height: auto;
        }

    }
    .whiter {
        width: 200px;
    }
    .forminfo {
        @media (min-width: 1200px) {
            width: 500px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue